export interface IVisitConsentEuthanasiaRequest {
  euthanasiaResponseId: number;
}

export class VisitConsentEuthanasiaRequest
  implements IVisitConsentEuthanasiaRequest
{
  euthanasiaResponseId: number;

  constructor(params: IVisitConsentEuthanasiaRequest) {
    this.euthanasiaResponseId = _.defaultTo(params.euthanasiaResponseId, 0);
  }
}
